import { makeStyles } from '@mui/styles';

export const useIntegrationsPageStyle = makeStyles(() => ({
  cardContainer: {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: 304,
  },
}));
